const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22.4c-5.333 0-9.6-3.733-11.733-6.4C6.4 13.334 10.667 9.6 16 9.6s9.6 3.734 11.733 6.4c-2.133 2.667-6.4 6.4-11.733 6.4M16 0c8.836 0 16 7.164 16 16 0 8.837-7.164 16-16 16S0 24.837 0 16C0 7.164 7.164 0 16 0zm0 10.667a5.334 5.334 0 100 10.665 5.334 5.334 0 000-10.665z"
});

const SvgSee = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6fdcf8",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/see.4e6c34e3.svg";
export { ForwardRef as ReactComponent };